import { Injectable } from '@angular/core';
import { IAppState } from '@myStore/app.state';
import {
  EProfileViewActions,
  GetProfileFailure,
  GetProfileRequest,
  GetProfileSuccess,
} from '@myStore/profile-view/profile-view.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { UsersViewService } from '@services/usersView/usersView.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ProfileViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _usersViewService: UsersViewService
  ) {}

  get$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetProfileRequest>(EProfileViewActions.GetProfileRequest),
        switchMap(action => {
          return this._usersViewService.getUser(action.id).pipe(
            map(res => {
              this._store.dispatch(new GetProfileSuccess(res));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении профиля возникла ошибка'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new GetProfileFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
